import React from 'react'
import { useDispatch } from 'react-redux'
import { Button } from '@frontend/ui-kit/agromarket/components/Button'
import { closeModal } from '@/components/composed/Modal/actions'
import { GlassMorphIcon } from '@/components/ui'
import { useDeviceType } from '@/utils/hooks/useDeviceType'
import { messages } from './messages'
import type { IFinancingCallbackStatusWrapperProps } from './types'
import './styles.scss'

export const FinancingCallbackStatusWrapper = (props: IFinancingCallbackStatusWrapperProps) => {
  const { icon, title, subtitle } = props

  const { isMobile } = useDeviceType()
  const dispatch = useDispatch()

  const closeCallbackModal = () => dispatch(closeModal())

  return (
    <div className="financingCallbackStatusWrapper">
      <GlassMorphIcon className="financingCallbackStatusWrapper__icon" image={icon} />

      <h4 className="financingCallbackStatusWrapper__title">{title}</h4>
      {subtitle && <div className="financingCallbackStatusWrapper__subtitle">{subtitle}</div>}

      <div className="financingCallbackStatusWrapper__actions">
        <Button className="financingCallbackStatusWrapper__action" onClick={closeCallbackModal} size={isMobile ? 'lg' : 'md'}>
          {messages.action}
        </Button>
      </div>
    </div>
  )
}
